/**
 * Password Encryption Utility
 *
 * Provides client-side password encryption using Base64 encoding.
 */

/**
 * Encrypts a plain text password before sending to the server
 */
export function encrypt(password: string): string {
  if (!password) {
    return '';
  }

  try {
    return btoa(password);
  } catch (error) {
    console.error('Error encrypting password:', error);
    return password;
  }
}
